module.exports = __webpack_public_path__ + "img/register.78822569.svg";